import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { rolPost } from "../../store/rol/actions";
export var useRolPost = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseRolPost: state.Rol.responseRolPost,
        errorRolPost: state.Rol.errorRolPost,
        loadingRolPost: state.Rol.loadingRolPost,
    }); }), responseRolPost = _a.responseRolPost, errorRolPost = _a.errorRolPost, loadingRolPost = _a.loadingRolPost;
    useEffect(function () {
        if (trigger) {
            dispatch(rolPost({
                roles: [
                    {
                        name: body.RolName,
                        description: body.RolDescription,
                    },
                ],
            }));
        }
    }, [trigger]);
    return {
        responseRolPost: responseRolPost,
        errorRolPost: errorRolPost,
        loadingRolPost: loadingRolPost,
    };
};
